import type { LinkProps } from 'next/link';
import NextLink from 'next/link';
import type { AnchorHTMLAttributes } from 'react';

import { cn } from '../../utils/cva';

type Props = Omit<LinkProps, 'as'> & AnchorHTMLAttributes<HTMLAnchorElement>;

export const Link = (props: Props) => {
  const { children, href, className, ...rest } = props;

  if (!href) return null;

  return (
    <NextLink
      className={cn('cursor-pointer no-underline decoration-0 **:transition-all', className)}
      href={href}
      prefetch={false}
      {...rest}
      scroll={true}
    >
      {children}
    </NextLink>
  );
};
